
import React      from 'react';
import CSSModules from 'react-css-modules';

import Button                 from '../Button';
import FontIcon               from '../FontIcon';
import ResourcePackForm       from '../ResourcePackForm';
import Overlay                from '../Overlay';
import YesNoOptionPanel       from '../YesNoOptionPanel';

import * as resourcePackList from '../../actions/resourcePackList';

import { connect } from 'react-redux';

import style from './style.scss';

class ResourceList extends React.Component {

    componentDidMount() {

        this.props.refreshResourcePacks();
    }

    _getDeletePackOverlayContent() {

        if (this.props.isDeleteResourcePackOverlayOpen) {

            const { packToDelete } = this.props;

            return (
                <div>

                    <p>
                        Are you sure you want to to delete the&nbsp;

                        <span styleName="pack-to-delete">
                            { packToDelete.name }
                        </span>

                        &nbsp;pack?
                    </p>

                    <YesNoOptionPanel no={ this.props.hideDeletePackOverlay }
                                      yes={ this.props.deleteResourcePack.bind(this, packToDelete.id) } />

                </div>
            );
        }
    }

    render() {

        return (

            <article>

                <Overlay isOpen={ this.props.isDeleteResourcePackOverlayOpen }
                         closeOverlay={ this.props.hideDeletePackOverlay }
                         title="Delete Resource Pack"
                         size="small">

                    { this._getDeletePackOverlayContent() }

                </Overlay>

                <Overlay isOpen={ this.props.isEditResourcePackOverlayOpen }
                         closeOverlay={ this.props.hideEditPackOverlay }
                         title="Edit Resource Pack"
                         size="medium">

                    <ResourcePackForm mode="edit" submitted={ this.props.resourcePackEdited } />

                </Overlay>

                <Overlay isOpen={ this.props.isNewResourcePackOverlayOpen }
                         closeOverlay={ this.props.toggleNewResourcePackOverlay }
                         title="New Resource Pack"
                         size="medium">

                    <ResourcePackForm mode="add" submitted={ this.props.resourcePackAdded } />

                </Overlay>

                <Button onClick={ this.props.toggleNewResourcePackOverlay }
                        className={ style['new-resource-set-button'] }>

                    <FontIcon textPosition="right" iconName="plus" />
                    <span>New resource pack</span>

                </Button>

                <section>

                    {
                        this.props.packs.map((pack, index) => {

                            return (
                                <article key={ index } styleName="resource-pack">

                                    <FontIcon className={ style['resource-pack-icon'] } iconName="folder">
                                        <span styleName="resource-file-number">{ pack.files_count }</span>
                                    </FontIcon>

                                    <div styleName="resource-details">
                                        <span>{ pack.name }</span>

                                        <div styleName="resource-actions">

                                            <a styleName="resource-action"
                                               onClick={ this.props.showEditPackOverlay.bind(this, pack) }>
                                                Edit
                                            </a>

                                            <a styleName="resource-action"
                                               onClick={ this.props.showDeletePackOverlay.bind(this, pack) }>
                                                Delete
                                            </a>

                                        </div>
                                    </div>

                                </article>
                            );
                        })
                    }

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.resourcePackList;
}

function mapDispatchToProps(dispatch) {

    return {
        resourcePackEdited() {

            dispatch(resourcePackList.hideEditPackOverlay());
            dispatch(resourcePackList.refreshResourcePacks());
        },
        resourcePackAdded() {

            dispatch(resourcePackList.toggleNewResourcePackOverlay());
            dispatch(resourcePackList.refreshResourcePacks());
        },
        showEditPackOverlay(pack) {

            dispatch(resourcePackList.showEditPackOverlay(pack));
        },
        hideEditPackOverlay() {

            dispatch(resourcePackList.hideEditPackOverlay());
        },
        deleteResourcePack(packId) {

            dispatch(resourcePackList.deleteResourcePack(packId));
        },
        hideDeletePackOverlay() {

            dispatch(resourcePackList.hideDeletePackOverlay());
        },
        showDeletePackOverlay(pack) {

            dispatch(resourcePackList.showDeletePackOverlay(pack));
        },
        refreshResourcePacks() {

            dispatch(resourcePackList.refreshResourcePacks());
        },
        toggleNewResourcePackOverlay() {

            dispatch(resourcePackList.toggleNewResourcePackOverlay());
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(ResourceList, style));


// WEBPACK FOOTER //
// ./components/ResourceList/index.js